import type { FC } from 'react'
import { IkyuRestaurantWhiteLogo, PaypayGourmetWhiteLogo } from '~/components/logos'

function IkyuReservationCompleteHeader() {
  return (
    <header className="flex flex-initial flex-row justify-between pt-5">
      <a href="/" className="inline-block">
        <IkyuRestaurantWhiteLogo />
      </a>
    </header>
  )
}

function PpgReservationCompleteHeader() {
  return (
    <header className="flex flex-initial flex-row justify-between pt-5">
      <a href="/" className="inline-block">
        <PaypayGourmetWhiteLogo />
      </a>
    </header>
  )
}

// FIXME ロゴがあちこちに散らばってるので一箇所にまとめる...
//       今は PPG 検証なので整理は別で
const ReservationCompleteHeader: FC =
  import.meta.env.VITE_MODE === 'ppg' ? PpgReservationCompleteHeader : IkyuReservationCompleteHeader

export default ReservationCompleteHeader
